import { ColumnEditorOptions } from "primereact/column";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";

interface NumberEditorProps {
    options: ColumnEditorOptions;
    unit?: string;
    min?: number;
    max?: number;
}

export const NumberEditor = ({ options, unit, min, max }: NumberEditorProps) => {
    const handleChange = (e: InputNumberValueChangeEvent) => {
        if (options.editorCallback) {
            options.editorCallback(e.value);
        }
    };

    // Parse the current value
    let currentValue = options.value;
    if (typeof currentValue === "string") {
        const parsed = parseFloat(currentValue);
        currentValue = isNaN(parsed) ? null : parsed;
    }

    return (
        <div className="flex align-items-center gap-2">
            <InputNumber
                value={currentValue}
                onValueChange={handleChange}
                mode="decimal"
                minFractionDigits={0}
                maxFractionDigits={4}
                min={min}
                max={max}
                autoFocus
            />
            {unit && <span className="text-sm text-color-secondary">{unit}</span>}
        </div>
    );
};

export const numberDisplayTemplate = (value: unknown, unit?: string): string => {
    if (value === null || value === undefined || value === "") return "";

    const numValue = typeof value === "string" ? parseFloat(value) : value;
    if (typeof numValue !== "number" || isNaN(numValue)) return String(value);

    return unit ? `${numValue} ${unit}` : String(numValue);
};
